export enum requestStatuses {
  Approve = 'approved',
  Cancel = 'canceled',
  New = 'new'
}
